import { format } from 'date-fns';
import { getDefaultTaskFilter } from '../components/TaskFilter/TaskFilterHelper';

const initState = {
  loading: false,
  tasks: [],
  guestAvailableTasks: [],
  guestAvailableTasksLoading: false,
  guestTaskDialogGuestId: null,
  guestTaskDialogGuestName: null,
  filters: getDefaultTaskFilter(),
  filtersChanged: false,
  filterOpen: false,
};

const compareArrays = (array1, array2) => {
  return (
    array1.length === array2.length &&
    array1.every((value, index) => value === array2[index])
  );
};

const TasksReducer = function (state = initState, action) {
  switch (action.type) {
    case 'TASKS_SET_SEARCH_TEXT': {
      return {
        ...state,
        filters: { ...state.filters, titleFilter: action.searchText },
      };
    }

    case 'GET_TASKS_PENDING': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'GET_TASKS_REJECTED': {
      return {
        ...state,
        loading: false,
      };
    }
    case 'GET_TASKS_FULFILLED': {
      return {
        ...state,
        tasks: action.payload,
        loading: false,
      };
    }
    case 'OPEN_GUEST_TASK_DIALOG': {
      return {
        ...state,
        guestTaskDialogGuestId: action.guestId,
        guestTaskDialogGuestName: action.guestName || null,
      };
    }

    case 'CLOSE_GUEST_TASK_DIALOG': {
      return {
        ...state,
        guestTaskDialogGuestId: null,
        guestTaskDialogGuestName: null,
        guestAvailableTasks: [],
      };
    }

    case 'GET_GUEST_AVAILABLE_TASKS_PENDING': {
      return {
        ...state,
        guestAvailableTasks: [],
        guestAvailableTasksLoading: true,
      };
    }
    case 'GET_GUEST_AVAILABLE_TASKS_REJECTED': {
      return {
        ...state,
        guestAvailableTasksLoading: false,
      };
    }
    case 'GET_GUEST_AVAILABLE_TASKS_FULFILLED': {
      return {
        ...state,
        guestAvailableTasks: action.payload || [],
        guestAvailableTasksLoading: false,
      };
    }

    case 'ADD_GUEST_TO_TASK_PENDING': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'ADD_GUEST_TO_TASK_REJECTED': {
      return {
        ...state,
        loading: false,
      };
    }
    case 'ADD_GUEST_TO_TASK_FULFILLED': {
      return {
        ...state,
        loading: false,
      };
    }

    case 'SET_FILTERS': {
      const defValues = getDefaultTaskFilter();
      const realValues = action.payload;
      const diff =
        defValues.titleFilter === realValues.titleFilter &&
        compareArrays(
          defValues.adminClientCompanyOwners,
          realValues.adminClientCompanyOwners
        ) &&
        compareArrays(defValues.statuses, realValues.statuses) &&
        compareArrays(defValues.clients, realValues.clients) &&
        compareArrays(defValues.assignees, realValues.assignees) &&
        format(new Date(defValues.creationDateFrom), 'y-MM-dd') ===
        format(new Date(realValues.creationDateFrom), 'y-MM-dd') &&
        format(new Date(defValues.creationDateTo), 'y-MM-dd') ===
        format(new Date(realValues.creationDateTo), 'y-MM-dd');

      return {
        ...state,
        filters: action.payload,
        filtersChanged: !diff,
      };
    }

    case 'RESET_FILTERS': {
      return {
        ...state,
        filters: getDefaultTaskFilter(),
        filtersChanged: false,
      };
    }

    case 'TOGGLE_TASK_FILTER':
      return {
        ...state,
        filterOpen: action.payload
      };

    default:
      return state;
  }
};

export default TasksReducer;
